import React, { Component } from "react";
import { Icon, Tooltip, Radio } from "antd";
import PropTypes from "prop-types";

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

class Input extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.storeValue = this.storeValue.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);

    const { isValid, isFocused, firstLoad, value } = this.props;

    this.state = {
      isValid,
      isFocused,
      firstLoad,
      value
    };
  }

  componentDidMount() {
    setTimeout(() => {
      if (!this.ref) return;
      let val = this.ref.value;
      if (!val && this.ref.props) val = this.ref.props.value;
      const { isValid = false } = this.validateAndFormat(val);
      this.setState({ isValid });
    }, 200);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    this.setState({ value, firstLoad: false });
  }

  storeValue(input) {
    this.ref = input;
  }

  validateAndFormat(value, loi) {
    const { validator, byPassValidation } = this.props;

    let isValid = true;

    if (byPassValidation && value) {
      return { value, isValid };
    }

    //eval is harmful so checking validator
    const re = /answer\s(===|==|<=|>=|<|>)\s([0-9]\s\*\sloi|false|true|[0-9])/;
    let reValid = re.test(validator);
    let replaceItems = {
      "==": "===",
      true: "'true'",
      false: "'false'"
    };

    if (validator.length > 0 && reValid) {
      let answer = value;
      let newValidator = validator;
      for (let item in replaceItems) {
        if (validator.includes(item)) {
          newValidator = validator.replace(item, replaceItems[item]);
        }
      }
      isValid = eval(newValidator);
    }

    return { value, isValid };
  }

  handleChange(e) {
    const { loi, name } = this.props;
    const { value, isValid } = this.validateAndFormat(e.target.value, loi);
    this.setState({ value, isValid });
    this.props.onChange(e.target.value, isValid, name);
  }

  handleFocus() {
    this.setState({ isFocused: true });
  }

  handleBlur(e) {
    const { isValid } = this.validateAndFormat(e.target.value, this.props.loi);
    const nextState = { isValid, isFocused: false };
    if (this.state.firstLoad) {
      nextState.firstLoad = false;
    }

    this.setState(nextState);
  }

  onKeyPress(e, name) {
    let val,
      keyCode = e.which;
    if (keyCode === 121) val = "true";
    if (keyCode === 110) val = "false";

    const { value, isValid } = this.validateAndFormat(val, this.props.loi);
    this.setState({ value, isValid });
    this.props.onChange(value, isValid, name);
  }

  renderRequiredMsg = () => {
    const { required } = this.props;
    const { isValid, isFocused } = this.state;

    if (required) {
      return !isFocused && !isValid && <span className="error">Required</span>;
    }

    // Return nothing.
    return required && <React.Fragment />;
  };

  renderMessage = () => {
    const { value, isValid } = this.state;
    const { required, message } = this.props;

    if (required && value.length !== 0 && message) {
      return value.length !== 0 && !isValid && message;
    }

    return this.renderRequiredMsg();
  };

  render() {
    const {
      label,
      name,
      type,
      disabled,
      placeholder,
      textArea,
      tooltip
    } = this.props;

    const { value, isValid, isFocused } = this.state;

    let blockClassName = textArea ? "textarea-block" : "input-block";

    if (!isValid) blockClassName += " error";
    if (isFocused) blockClassName += " focus";

    const input = textArea ? (
      <textarea
        ref={this.storeValue}
        disabled={disabled}
        type={type}
        value={value}
        name={name}
        placeholder={placeholder}
        className="textarea"
        onChange={this.handleChange}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
      />
    ) : type === "number" ? (
      <input
        ref={this.storeValue}
        disabled={disabled}
        type={type}
        value={value}
        name={name}
        placeholder={placeholder}
        className="input"
        onChange={this.handleChange}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
      />
    ) : (
      <RadioGroup
        ref={this.storeValue}
        value={value}
        name={name}
        onChange={this.handleChange}
        disabled={disabled}
      >
        <RadioButton value="true">Yes</RadioButton>
        <RadioButton value="false">No</RadioButton>
      </RadioGroup>
    );
    const tooltipIcon = tooltip && (
      <Tooltip title={tooltip}>
        <Icon type="question-circle-o" />
      </Tooltip>
    );

    return (
      <div
        tabIndex="0"
        className={`block ${blockClassName}`}
        onKeyPress={
          type === "radio" ? e => this.onKeyPress(e, name) : undefined
        }
      >
        <label className="input-label">
          {label} {tooltipIcon}
        </label>
        {input}
        <div className="message">{this.renderMessage()}</div>
      </div>
    );
  }
}

Input.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  hideBar: PropTypes.bool,
  validator: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  onChange: PropTypes.func,
  isValid: PropTypes.bool,
  isFocused: PropTypes.bool,
  firstLoad: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  required: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]), // Display `Required` message
  byPassValidation: PropTypes.bool
};

Input.defaultProps = {
  name: "",
  label: "",
  type: "text",
  disabled: false,
  hideBar: false,
  validator: value => {
    return value.trim().length > 0;
  },
  onChange: (value, name) => {
    return value;
  },
  isValid: true,
  isFocused: false,
  firstLoad: true,
  value: "",
  required: true,
  byPassValidation: false
};

export default Input;
